import { render, staticRenderFns } from "./captcha.vue?vue&type=template&id=d1114552&scoped=true&"
import script from "./captcha.vue?vue&type=script&lang=js&"
export * from "./captcha.vue?vue&type=script&lang=js&"
import style0 from "./captcha.vue?vue&type=style&index=0&id=d1114552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1114552",
  null
  
)

export default component.exports